// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { validateAccountNumber } from '@guestsupply/App/Services/RequestWebsiteAccessService';
import { AccountInfoModel } from "@guestsupply/XDL/types";
import {
    ApiHandler,
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

export interface ValidateAccountNumberParameter {
    accountNumber: string;
}

type HandlerType = ApiHandler<
ValidateAccountNumberParameter & HasOnSuccess<any> & HasOnError<unknown>,
AccountInfoModel
>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    if (!props.apiParameter.accountNumber) {
        return;
    }

    try {
        props.apiResult = await validateAccountNumber(props.apiParameter.accountNumber);
    } catch (error) {
        props.parameter.onError?.(error);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    ExecuteOnSuccessCallback,
];

const validateAccountNumberHandler = createHandlerChainRunner(chain, "ValidateAccountNumberHandler");

export default validateAccountNumberHandler;
